"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const json_api_normalizer_1 = __importDefault(require("json-api-normalizer"));
exports.normalize = (json, options = {}) => {
    const entities = json_api_normalizer_1.default(json, options);
    const result = json.data.map(({ id }) => id);
    const meta = json.meta;
    return { entities, result, meta };
};
//# sourceMappingURL=normalize.js.map